import React, { useContext } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { DataContext } from '../../../../../context/DataContext';
import { PageContainer } from '../../../components/AdminContentWrapper';

/**
 * Gate de UI para las pantallas de créditos/facturación. El backend
 * (billing-admin) ya autoriza estrictamente por `cognito:groups` -- esto
 * es solo para no renderizar formularios/acciones que de todos modos van
 * a devolver 403/404, y para no confundir a un usuario sin acceso.
 *
 * `allow="root"` -- solo rol root (plataforma).
 * `allow="root-or-admin"` -- root o admin (rutas de un tenant).
 */
const RequireBillingRole = ({ allow = 'root-or-admin', title, children }) => {
  const { isPlatformRoot, isTenantAdmin } = useContext(DataContext);
  const authorized = allow === 'root' ? isPlatformRoot : isPlatformRoot || isTenantAdmin;

  if (!authorized) {
    return (
      <PageContainer title={title || 'Créditos y facturación'}>
        <Alert severity="warning">
          <AlertTitle>Acceso restringido</AlertTitle>
          Esta sección requiere el rol {allow === 'root' ? '"root" (administrador de plataforma)' : '"root" o "admin"'} en
          Cognito. Si crees que deberías tener acceso, contacta al administrador de tu cuenta.
        </Alert>
      </PageContainer>
    );
  }

  return <Box>{children}</Box>;
};

export default RequireBillingRole;
